(function() {

	"use strict";

	/**
	*	imgFallback
	*
	*	simple onerror image fallback
	* 	onerror replaces image's src with Conf.imagesPlaceholder
	*/

	angular
		.module('ATMGurus')
		.directive('imgFallback', imgFallback)

	imgFallback.$inject = ['ATMGConf'];

	function imgFallback(Conf) {
		return {
			restrict: "A",
			scope: false,
			link: function(scope, element, attrs) {
				var self = this;
				element.bind( "error", function() {
					$(this).attr("src", Conf.imagesPlaceholder);
				})
			}
		}
	}

})()


// WEBPACK FOOTER //
// ./src/app/directives/img-fallback.js